module.exports = __webpack_public_path__ + "2d2ee742998ddaec7531c689fdc74aaa.png";